module.exports = __webpack_public_path__ + "static/scale-model-of-fishermans-wharf-in-san-francisco-california-b769cb1a11a087f8e28da9b9e5c836b8.png";